import api from '@/api/index.js'

const municipality = {
  state: {
    loading: false,
    data: null,
    error: null
  },

  mutations: {
    SET_MUNICIPALITY_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_MUNICIPALITY: (state, response) => {
      state.data = response
      state.loading = false
    },
    SET_MUNICIPALITY_ERROR: (state, error) => {
      state.error = error
    },
    SET_MUNICIPALITY_FILTER_DETAILS: (state, filterDetails) => {
      state.filterDetails = filterDetails
    }
  },

  actions: {
    LoadMunicipality({commit}, query) {
        commit('SET_MUNICIPALITY', null)
      commit('SET_MUNICIPALITY_ERROR', null)
      commit('SET_MUNICIPALITY_LOADING', true)
      return api.get(`municipalities/${query.id}`)
        .then((response) => {
          commit('SET_MUNICIPALITY', response)
        })
        .catch((error) => {
          commit('SET_MUNICIPALITY_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_MUNICIPALITY_LOADING', false)
        })
    }
  }
}

export default municipality
